module.exports = __webpack_public_path__ + "static/media/LogoLife.f2c57097.png";